import { render, staticRenderFns } from "./patrol01.vue?vue&type=template&id=bd8ddab0"
import script from "./patrol01.vue?vue&type=script&lang=js"
export * from "./patrol01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd8ddab0')) {
      api.createRecord('bd8ddab0', component.options)
    } else {
      api.reload('bd8ddab0', component.options)
    }
    module.hot.accept("./patrol01.vue?vue&type=template&id=bd8ddab0", function () {
      api.rerender('bd8ddab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/patrol01.vue"
export default component.exports